import AppleConfiguration from './AppleConfiguration';

export default AppleConfiguration;
